import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHomeEnergy2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconHomeEnergy2"><Path d="M11.9995 1.82764L22.5459 9.37798L21.6728 10.5976L19.9995 9.39973V21H14.9995V19.5H18.4995V8.32586L11.9995 3.67241L5.49951 8.32588V19.5H8.99951V21H3.99951V9.39975L2.3263 10.5976L1.45312 9.37798L11.9995 1.82764Z" fill="currentColor"/><Path d="M13.2495 11H10.7495V9H9.24951V11H7.99951V17H11.2495V21H12.7495V17H15.9995V11H14.7495V9H13.2495V11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHomeEnergy2;
